module.exports = "<header-mov></header-mov>\r\n<div class=\"principal\" fxLayout=\"row\">\r\n    <summary-mov fxFlex=\"80%\"></summary-mov>\r\n</div>"